/**
 * SEO Utilities for Javier Montero Palma's Portfolio
 */

interface ServiceItem {
  title: string;
  description: string;
}

export function generateConsultantJsonLd(lang: 'en' | 'es') {
  const isEn = lang === 'en';
  return {
    "@context": "https://schema.org",
    "@type": "Person",
    "name": "Javier Montero Palma",
    "url": "https://javier-montero.com",
    "image": "https://javier-montero.com/goodMe.jpg",
    "jobTitle": isEn ? "Technology Consultant" : "Consultor Tecnológico",
    "description": isEn 
      ? "Strategic Technology Partner helping businesses grow through reliable tech advisory and automation."
      : "Socio tecnológico estratégico que ayuda a las empresas a crecer mediante asesoría técnica confiable y automatización.",
    "sameAs": [
      "https://www.linkedin.com/in/javier-montero-9304792b/",
    ]
  };
}

export function generateServiceCatalogJsonLd(services: ServiceItem[], lang: 'en' | 'es') {
  const isEn = lang === 'en';
  return {
    "@context": "https://schema.org",
    "@type": "Service",
    "serviceType": isEn ? "Technology Consulting" : "Consultoría Tecnológica",
    "provider": {
      "@type": "Person",
      "name": "Javier Montero Palma",
      "url": "https://javier-montero.com"
    },
    "hasOfferCatalog": {
      "@type": "OfferCatalog",
      "name": isEn ? "Consulting Services" : "Servicios de Consultoría",
      "itemListElement": services.map((service, index) => ({
        "@type": "OfferCatalog",
        "position": index + 1,
        "name": service.title,
        "description": service.description
      }))
    }
  };
}

export function updateMetaTags(lang: 'en' | 'es') {
  const isEn = lang === 'en';
  const title = isEn ? "Javier Montero | Technology Consultant" : "Javier Montero | Consultor Tecnológico";
  const description = isEn 
    ? "I handle the tech, so you can grow. Reliable tech advisory and automation for your business."
    : "Yo manejo la tecnología para que tú puedas crecer. Asesoría tecnológica y automatización para tu negocio.";

  document.title = title;
  
  const metaDescription = document.querySelector('meta[name="description"]');
  if (metaDescription) {
    metaDescription.setAttribute('content', description);
  }

  const ogTitle = document.querySelector('meta[property="og:title"]');
  if (ogTitle) ogTitle.setAttribute('content', title);

  const ogDesc = document.querySelector('meta[property="og:description"]');
  if (ogDesc) ogDesc.setAttribute('content', description);

  const twitterTitle = document.querySelector('meta[name="twitter:title"]');
  if (twitterTitle) twitterTitle.setAttribute('content', title);

  const twitterDesc = document.querySelector('meta[name="twitter:description"]');
  if (twitterDesc) twitterDesc.setAttribute('content', description);
}

export function injectJsonLd(data: object, id: string) {
  let script = document.getElementById(id) as HTMLScriptElement;
  if (!script) {
    script = document.createElement('script');
    script.id = id;
    script.type = 'application/ld+json';
    document.head.appendChild(script);
  }
  script.text = JSON.stringify(data);
}
